export default {
  appName: 'platzimusic',
  apiKey:  '58f885506bf0e210d16698e5416560ca',
  secret:  '5568a1aa4c8b668acf177c7af2f007a2',
  registeredTo: 'hackvan'
}


// WEBPACK FOOTER //
// ./src/api/config.js